// Stripe Checkout cancel landing page.
//
// User clicked "Back" on Stripe's hosted Checkout page, or otherwise abandoned
// the flow before payment. No charge happened. We just bounce them back to
// /checkout so they can try again.

import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';

export default function CheckoutCancelPage() {
  const navigate = useNavigate();
  const { signOut } = useAuth();

  return (
    <div className="min-h-screen bg-surface flex items-center justify-center p-6">
      <div className="max-w-md w-full bg-white rounded-2xl border border-surface-dark/40 shadow-lg p-8 text-center">
        <div className="w-16 h-16 mx-auto mb-5 rounded-full bg-amber-100 flex items-center justify-center">
          <i className="ri-information-line text-amber-600 text-3xl" />
        </div>

        <h1 className="font-display font-bold text-dark text-2xl mb-2">
          Payment cancelled
        </h1>
        <p className="text-dark-muted text-sm mb-6">
          No charge was made. You can pick a plan again whenever you're ready.
        </p>

        <div className="flex flex-col gap-2">
          <button
            onClick={() => navigate('/checkout')}
            className="w-full px-6 py-3 rounded-full bg-primary hover:bg-primary-hover text-white text-sm font-bold transition-colors cursor-pointer"
          >
            Back to plans
          </button>
          <button
            onClick={() => { void signOut(); }}
            className="w-full px-6 py-3 rounded-full bg-surface text-dark text-sm font-semibold hover:bg-surface-dark/20 transition-colors cursor-pointer"
          >
            Sign out
          </button>
        </div>
      </div>
    </div>
  );
}
